/* eslint-disable no-param-reassign */

import api from '@/services/api/project/project';
import taskApi from '@/services/api/task/task'
import { Storage, Cookie } from "@/utils/utils";
export default {
  state: {
    projectList: [],
    projectEditData: {},
    memberList: [],
    project_id: '',
    newMember: [],
    taskMemberList: [],
    c: '',
    isAdmin: false,
    isCeartor: false,
    userInfo: Storage.get('wfUserInfo') ? Storage.get('wfUserInfo') : {}
  },
  mutations: {
    SET_DATALIST: (state, data) => {
      state.projectList = data;
    },
    SET_PROJECTEDIT: (state, data) => {
      state.projectEditData = data
    },
    SET_PROJECTID: (state, data) => {
      state.project_id = data
    },
    SET_PROJECTMEMBER: (state, data) => {
      state.memberProject = data
    },
    set_member_user: (state, data) => {
      let dataset = []
      let userInfo = Storage.get('wfUserInfo')
      state.isAdmin = false
      state.isCeartor = false
      data.forEach((res) => {
        for (let key in res) {
          if (!state.isAdmin) {
            res[key].find((temp) => {
              if (temp.uid == userInfo.uid && [1, 2].indexOf(temp.type) > -1) {
                state.isAdmin = true
                if ([1].indexOf(temp.type) > -1) {
                  state.isCeartor = true
                }
                return true
              }
            })
          }
          dataset.push({
            realname: key,
            children: res[key] || []
          })
        }
      })
      state.newMember = dataset
    }
  },
  getters: {},
  actions: {
    getDepartmentProjectfolder({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .getDepartmentProjectfolder(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getProjectListByDepartment({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .getProjectListByDepartment(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getProjectList({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .getProjectList()
          .then((res) => {
            commit('SET_DATALIST', res)
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    addProject({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .addProject(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    editProject({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .editProject(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getProjectMember({
      commit, state
    }, params) {
      return new Promise((resolve, reject) => {
        if (state.project_id === params.project_id) {
          resolve(state.memberList)
          return
        }
        commit('SET_PROJECTID', params.project_id)
        api.getProjectMember(params).then((res) => {
          state.memberList = JSON.parse(JSON.stringify(res))
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    getNewProjectMember({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        if (state.memberProject === params.project_id) {
          resolve(state.newMember)
          return
        }
        commit('SET_PROJECTMEMBER', params.project_id)
        taskApi.getProjectMembers(params).then((res) => {
          commit('set_member_user', res)
          resolve(state.newMember)
        }).catch((error) => {
          console.log(error)
          reject(error);
        });
      })
    },
    getTaskMember({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        taskApi.getTaskMembers(params).then((res) => {
          let dataset = []
          res.forEach(res => {
            for (let key in res) {
              dataset.push({
                realname: key,
                children: res[key],
              })
            }
          })
          resolve(dataset)
          state.taskMemberList = JSON.parse(JSON.stringify(dataset))
        }).catch((error) => {
          reject(error);
        })
      })
    },
    updateProjectMember({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .updateProjectMember(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteProjectMember({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .deleteProjectMember(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateorderby({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .updateorderby(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    deleteproject({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .deleteproject(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getProjectFolderlist({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .getProjectFolderlist(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    addProjectFolder({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .addProjectFolder(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateProjectFolder({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .updateProjectFolder(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    delProjectFolder({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .delProjectFolder(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getProjectUnreadMessage({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .getProjectUnreadMessage(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    setProjectMessageIsRead({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .setProjectMessageIsRead(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getProjectByStatus({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .getProjectByStatus(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    archiveProject({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .archiveProject(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    activateProject({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .activateProject(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getArchiveProjectList({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .getArchiveProjectList(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    activeProjectStatus({
      commit
    }, params) {
      return new Promise((resolve, reject) => {
        api
          .activeProjectStatus(params)
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  },
};
